import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route, useParams } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import InternalPage from "@/pages/InternalPage";
import RegionalPage from "@/pages/RegionalPage";
import { internalPages, regions } from "@/data/siteData";

const DynamicPage = () => {
  const { slug } = useParams();
  if (internalPages[slug]) return <InternalPage />;
  if (regions.some((region) => region.slug === slug)) return <RegionalPage />;
  return <Navigate to="/" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:slug" element={<DynamicPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
